import { render, staticRenderFns } from "./CurRefundApply2.vue?vue&type=template&id=32779ed3&scoped=true&"
import script from "./CurRefundApply2.vue?vue&type=script&lang=js&"
export * from "./CurRefundApply2.vue?vue&type=script&lang=js&"
import style0 from "./CurRefundApply2.vue?vue&type=style&index=0&id=32779ed3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32779ed3",
  null
  
)

export default component.exports